import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CarouselControls } from './CarouselControls';
import { BONOS } from './salesData';
import { useCarousel } from '../hooks/useCarousel';
export function BonosSection() {
  const {
    trackRef,
    index,
    goTo
  } = useCarousel(BONOS.length);
  return <section id="bonos" className="overflow-hidden bg-white py-12 sm:py-16" data-id="element-38" data-mp="yeks0fr2edvd">
      <div className="mx-auto max-w-5xl px-5" data-id="element-39" data-mp="tgj9bvxjwgkf">
        <div className="text-center" data-id="element-40" data-mp="ogn45td4aj3a">
          <SectionTag className="bg-cream" data-id="element-41" data-mp="oflsbmoa1ski">
            <GiftIcon className="h-3 w-3" aria-hidden strokeWidth={2.5} data-id="element-42" data-mp="oiriz6ck12ic" />
            4 bonos de regalo
          </SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[24ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-43" data-mp="fg8fql4uwnvk">
            Los tomos te dan las recetas. Los bonos te{' '}
            <span className="mark-yellow" data-id="element-44" data-mp="29v18mcecv0jt">ordenan la semana</span>.
          </h2>
          <p className="mx-auto mt-3 max-w-[44ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:max-w-2xl" data-id="element-45" data-mp="qv4wmm83apai">
            Vienen incluidos en la compra, sin costo adicional.
          </p>
        </div>

        <div ref={trackRef} role="region" aria-roledescription="carrusel" aria-label="Los 4 bonos de regalo" className="no-scrollbar relative -mx-5 mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto overscroll-x-contain scroll-px-5 px-5 sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 xl:grid-cols-4" data-id="element-46" data-mp="hvrllp4bhsno">
          {BONOS.map(bono => <article key={bono.num} role="group" aria-roledescription="diapositiva" aria-label={`Bono ${bono.num} de ${BONOS.length}: ${bono.name}`} className="flex w-[78%] shrink-0 snap-start flex-col rounded-2xl border border-stone bg-white p-3 shadow-[0_14px_34px_-30px_rgba(25,23,19,0.6)] sm:w-auto" data-id="element-47" data-mp="10ssrrd9lxyt7">
              <div className="flex h-[260px] items-center justify-center rounded-xl bg-cream p-2" data-id="element-48" data-mp="283x2dqjvea5n">
                <img src={bono.cover} alt={`Portada del Bono ${bono.num}: ${bono.name}`} loading="lazy" decoding="async" width={1024} height={1536} className="h-full w-auto max-w-full object-contain drop-shadow-[0_12px_18px_rgba(25,23,19,0.18)]" data-id="element-49" data-mp="236wwbfn0t7ej" />
              </div>
              <div className="flex flex-1 flex-col px-1 pb-1 pt-3.5" data-id="element-50" data-mp="1kelyi0783zna">
                <p className="font-display text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-51" data-mp="1ffrit74jyr7e">
                  Bono {bono.num}
                </p>
                <h3 className="mt-1 font-display text-[0.95rem] font-bold leading-tight tracking-tight text-charcoal" data-id="element-52" data-mp="1afd6hcvx4v3k">
                  {bono.name}
                </h3>
                <p className="mt-1 font-sans text-[0.8rem] leading-snug text-taupe" data-id="element-53" data-mp="11h1izjqcmdfc">{bono.desc}</p>
                <p className="mt-auto flex items-center gap-1.5 pt-3 font-display text-[0.64rem] font-bold uppercase tracking-[0.06em] text-coral" data-id="element-54" data-mp="3d3bqzjgqdyjq">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0" aria-hidden strokeWidth={3} data-id="element-55" data-mp="3m4t731u5208f" />
                  Incluido sin costo adicional
                </p>
              </div>
            </article>)}
        </div>

        <CarouselControls label="Bono" index={index} count={BONOS.length} onGo={goTo} className="mt-5 sm:hidden" data-id="element-56" data-mp="2tgnmqg6zyd94" />
      </div>
    </section>;
}